import axios from 'axios'

const getPfiConnection = async (organizationId, programId) => {
    try {
        const response = await axios.get(
          `/organization/${organizationId}/program/${programId}/pfi`
        );
        return response.data;
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
};
export default getPfiConnection
